import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(relativeTime);


// Format the date as today/yesterday/1 day ago
export const dayFormat = (param, format) => {
  if (!param) {
    return '';
  }

  const date = dayjs(param);
  const now = dayjs();

  const time = date.format('hh:mm:ss A'); // Format for time

  // Check if the date is today
  if (date.isSame(now, 'day')) {
    return `Today at ${time}`;
  }

  // Check if the date is yesterday
  if (date.isSame(now.subtract(1, 'day'), 'day')) {
    return `Yesterday at ${time}`;
  }

  // For dates within the last 7 days, show relative time
  if (now.diff(date, 'day') < 7) {
    return `${date.fromNow()} at ${time}`; // e.g., "2 days ago at 03:45:12 PM"
  }

  // For older dates, show the formatted date and time
  return date.format(format);
};

export const changeDateFormat = param => {
  if (!param) {
    return ''
  }

  const date = new Date(param)
  const formattedDate = dayjs(date).format('MMDDYYYY')
  return formattedDate
}

export const customDateFormat = (param, format) => {
  if (!param) {
    return ''
  }

  const date = new Date(param)
  const formattedDate = dayjs(date).format(format)
  return formattedDate
}

export const getlocalDateTime = param => {
  const localDateString = param.toLocaleString()
  return localDateString
}

// Hello World = hello_world
// export function formatString (inputString) {
//   const stringWithUnderscores = inputString.replace(/ /g, '_')
//   const lowercaseString = stringWithUnderscores.toLowerCase()
//   return lowercaseString
// }

export const formatString = inputString => {
  if (typeof inputString === 'string') {
    const stringWithUnderscores = inputString.replace(/ /g, '_')
    const lowercaseString = stringWithUnderscores.toLowerCase()
    return lowercaseString
  }
}
